const platform = process.env.CORDOVA_PLATFORM && process.env.CORDOVA_PLATFORM !== 'browser' ? 'mobile' : 'desktop'
const useProductionBackend = process.env.NODE_ENV === 'production' || platform === 'mobile'

let baseUrl = 'sharekomry.com'
if (window.location.host.substr(-3) === 'net') {
    baseUrl = 'sharekomry.net'
}

module.exports = {
    constants: {
        clientUri: useProductionBackend ? `https://www.${baseUrl}` : 'http://localhost:8080',
        serverUri: useProductionBackend ? `https://backend.${baseUrl}` : 'http://127.0.0.1:8004',
        assetsUri: useProductionBackend ? `https://assets.${baseUrl}` : 'http://localhost:8004/data',
        platform: platform,
        paypalEnv: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox',
        paypalSandboxClientID: 'AfJdh3cJ2AesaU2fCorj2YQNFNeoTzfigNM9xD80SUN1Diyu-jgXEEySo13Ix7biYJhTi9nisie01AAw',
        paypalProductionClientID: 'AZqCDXL2BiM9Ij1fRTSWxEuF40Wt506vPefRYuiK6BR7ExbyX4sMBmyXJFdAf94ncUQu8tahksuBAhmV',
        stripeKey: process.env.NODE_ENV === 'production' ? 'pk_live_xA94g9DRsGIo1SNV9p8XsHvd' : `pk_test_Zm0rGTo8lWGehuWegDh21K7c00s5aVSMq8`
    },
    firebaseConfig: {
        apiKey: 'AIzaSyDvdG6wr9FTE3WpKK3LztPOwFWAREWnZVw',
        authDomain: 'sharekomry-1564668304248.firebaseapp.com',
        databaseURL: 'https://sharekomry-1564668304248.firebaseio.com',
        projectId: 'sharekomry-1564668304248',
        storageBucket: 'sharekomry-1564668304248.appspot.com',
        messagingSenderId: '756601747177',
        appId: '1:756601747177:web:104a969498a7d6efdbe278',
        measurementId: 'G-CN8LRVTHHB'
    }
}
